import { useId } from 'preact/hooks';
import icons, { IconId } from './icons';
import './Icon.less';

export type IconProps = {
    size?: 'x-small' | 'small' | 'medium' | 'large' | 'x-large';
    iconId: IconId;
    className?: string;
    onClick?: (event: MouseEvent) => void;
    color?: 'gradient-primary';
};

const Icon = ({
    size = 'medium',
    iconId,
    className = '',
    onClick,
    color
}: IconProps) => {
    const id = useId();
    return (
        <svg
            onClick={onClick}
            className={`bri-Icon bri-Icon-size-${size} ${color ? 'bri-gradient' : ''} ${className}`}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
        >
            {color && (
                <defs>
                    <linearGradient
                        id={id}
                        x1="27.7569"
                        y1="14.1372"
                        x2="2.40147"
                        y2="9.82463"
                        gradientUnits="userSpaceOnUse"
                    >
                        <stop
                            offset="0.0288398"
                            stopColor={'var(--gradient-primary-1)'}
                        />
                        <stop
                            offset="1"
                            stopColor={'var(--gradient-primary-2)'}
                        />
                    </linearGradient>
                </defs>
            )}
            <path
                d={icons[iconId]}
                fill={color ? `url(#${id})` : undefined}
            ></path>
        </svg>
    );
};

export default Icon;
